var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-3" },
    [
      _c(
        "b-card",
        { attrs: { title: "Konfigurasi Website" } },
        [
          _c("b-card-text", [
            _c("form", { staticClass: "mt-5" }, [
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Nama RS")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "name", $$v)
                        },
                        expression: "form.name",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Logo RS")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [_c("b-form-file", { on: { change: _vm.handleFileInput } })],
                  1
                ),
              ]),
              _vm._v(" "),
              _vm.form.logo
                ? _c("div", { staticClass: "form-group row pb-4" }, [
                    _c(
                      "label",
                      {
                        staticClass: "col-lg-3 text-lg-end pt-2",
                        attrs: { for: "select-poli" },
                      },
                      [_vm._v("Logo Preview")]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "col-lg-6" },
                      [
                        _c("b-img", {
                          staticStyle: { "max-width": "25%", height: "auto" },
                          attrs: {
                            src: "/assets/img/logo/logo-rs/" + _vm.logo_preview,
                          },
                        }),
                      ],
                      1
                    ),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Alamat RS")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.address,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "address", $$v)
                        },
                        expression: "form.address",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Nomor Telp RS")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.phone,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "phone", $$v)
                        },
                        expression: "form.phone",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Judul Halaman")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.app_title,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "app_title", $$v)
                        },
                        expression: "form.app_title",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c(
                  "label",
                  {
                    staticClass: "col-lg-3 text-lg-end pt-2",
                    attrs: { for: "select-poli" },
                  },
                  [_vm._v("Deskripsi Halaman")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c("b-form-input", {
                      attrs: { type: "text" },
                      model: {
                        value: _vm.form.app_desc,
                        callback: function ($$v) {
                          _vm.$set(_vm.form, "app_desc", $$v)
                        },
                        expression: "form.app_desc",
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "form-group row pb-4",
                  staticStyle: { display: "none" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "col-lg-3 text-lg-end pt-2",
                      attrs: { for: "select-poli" },
                    },
                    [_vm._v("Metode Antrean")]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-lg-6" },
                    [
                      _c("b-form-radio-group", {
                        attrs: {
                          options: _vm.option_metode_antrean,
                          "value-field": "value",
                          "text-field": "text",
                        },
                        model: {
                          value: _vm.form.metode_antrean,
                          callback: function ($$v) {
                            _vm.$set(_vm.form, "metode_antrean", $$v)
                          },
                          expression: "form.metode_antrean",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "form-group row pb-4" }, [
                _c("div", { staticClass: "col-lg-3 text-lg-end pt-2" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6" },
                  [
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "primary" },
                        on: { click: _vm.saveRsData },
                      },
                      [_vm._v("Simpan")]
                    ),
                    _vm._v(" "),
                    _c(
                      "b-button",
                      {
                        staticClass: "btn-sm",
                        attrs: { variant: "danger" },
                        on: { click: _vm.cancelAdd },
                      },
                      [_vm._v("Batal")]
                    ),
                  ],
                  1
                ),
              ]),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }